module.exports = __webpack_public_path__ + "img/equip-top.b57c581e.png";